import { render } from "./BtnWithIcon.vue?vue&type=template&id=4f112432&ts=true"
import script from "./BtnWithIcon.vue?vue&type=script&lang=ts"
export * from "./BtnWithIcon.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__